import { render, staticRenderFns } from "./TopCategories.vue?vue&type=template&id=1135d809&scoped=true&"
import script from "./TopCategories.vue?vue&type=script&lang=js&"
export * from "./TopCategories.vue?vue&type=script&lang=js&"
import style0 from "./TopCategories.vue?vue&type=style&index=0&id=1135d809&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1135d809",
  null
  
)

export default component.exports